import { Address } from "viem"

import useLiquidityPools from "./useLiquidityPools"

// TODO: Temporary solution
export default function useLiquidityPoolStats(
  token0Address: Address,
  token1Address: Address,
) {
  const { data, isFetching } = useLiquidityPools()

  return {
    data: data.find(
      ({ token0, token1 }) =>
        token0.address === token0Address && token1.address === token1Address,
    ),
    isFetching,
  }
}
